import { ArrowRight } from "lucide-react";
import type { Affiliate } from "@/lib/affiliates";
import { cn } from "@/lib/utils";

export function AffiliateTile({
  affiliate,
  eyebrow = "Annons",
  variant = "default",
}: {
  affiliate: Affiliate;
  eyebrow?: string;
  variant?: "default" | "prominent";
}) {
  const Icon = affiliate.icon;
  const prominent = variant === "prominent";
  return (
    <a
      href={affiliate.url}
      target="_blank"
      rel="sponsored noopener noreferrer"
      className={cn(
        "group flex items-center gap-3 sm:gap-4 rounded-md border transition-all p-3 sm:p-4 md:p-5",
        prominent
          ? "border-rule bg-surface-2/70 hover:bg-surface-2 hover:border-foreground/30"
          : "border-rule bg-card hover:border-foreground/20 hover:bg-surface-2/60",
      )}
    >
      <div
        className={cn(
          "h-9 w-9 sm:h-10 sm:w-10 rounded-md flex items-center justify-center shrink-0 transition-colors",
          prominent
            ? "bg-primary/10 text-primary group-hover:bg-primary/15"
            : "bg-secondary text-foreground group-hover:bg-secondary/70",
        )}
      >
        <Icon className="h-4 w-4" />
      </div>
      <div className="min-w-0 flex-1">
        <div className="text-[10px] uppercase tracking-[0.18em] text-muted-foreground flex items-center gap-1.5 truncate">
          <span className="inline-block h-1 w-1 rounded-full bg-muted-foreground/60 shrink-0" />
          <span className="truncate">{eyebrow} · {affiliate.name}</span>
        </div>
        <div className="text-sm md:text-base mt-1 text-foreground font-medium line-clamp-2">{affiliate.blurb}</div>
      </div>
      <ArrowRight className="h-4 w-4 text-muted-foreground group-hover:text-foreground group-hover:translate-x-0.5 transition-all shrink-0" />
    </a>
  );
}
